'use client'
import { useMemo } from 'react'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import { RichText } from '@/components/RichText/RichText'
import { type GridColumnsField, type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'
import { type StoryblokRichTextNode } from '@storyblok/richtext'
import { renderRichTextToJsx } from './richTextReactRenderer'
import { nestedRichTextContainer } from '@/components/RichText/RichText.css'

export type RichTextBlockProps = SbBaseBlockProps<{
  content: StoryblokRichTextNode
  layout?: GridColumnsField
  largeText?: boolean
}>

export const RichTextBlock = ({ blok, nested }: RichTextBlockProps) => {
  const content = useMemo(() => renderRichTextToJsx(blok.content), [blok.content])

  if (nested) {
    return (
      <RichText className={nestedRichTextContainer} largeText={blok.largeText}>
        {content}
      </RichText>
    )
  }

  return (
    <GridLayout.Root {...storyblokEditable(blok)}>
      <GridLayout.Content
        width={blok.layout?.widths ?? { _: '1', md: '2/3', xl: '1/2' }}
        align={blok.layout?.alignment ?? 'center'}
      >
        <RichText largeText={blok.largeText}>{content}</RichText>
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
RichTextBlock.blockName = 'richText'
